function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { transformSchemaToJSON, useFormFieldWithSelector } from 'formydable';
import React, { useEffect, useMemo } from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import InputCore from './InputCore';
import Icon from '../Icon';
import Button from '../Button';
import { normalize } from '../../common/utils/case';
import { useFormManager } from './FormCore';

const FieldArrayMultiple = ({
  template: {
    as: Template = React.Fragment,
    append: templateAppend,
    prepend: tempaltePrepend,
    ...templateProps
  } = {},
  name,
  schema,
  disabled,
  column = 2,
  immidiate,
  showAction,
  showIconAction,
  rowClassName,
  value,
  append,
  prepend
}) => {
  const {
    readonly
  } = useFormManager();
  const {
    fieldState,
    formUpdate,
    setFieldArray,
    setFieldArrays,
    removeFieldArray
  } = useFormFieldWithSelector(name, true);
  const defaultSchema = useMemo(() => {
    return Object.keys(schema).reduce((result, key) => {
      const {
        rules,
        label,
        value = ""
      } = schema[key];
      result[key] = {
        rules,
        label,
        value
      };
      return result;
    }, {});
  }, []);
  const states = fieldState;
  const count = states.length;
  useEffect(() => {
    if (value && value.length > 0) {
      const defaultArrayValues = value.map(item => {
        return Object.keys(defaultSchema).reduce((result, key) => {
          result[key] = { ...defaultSchema[key],
            value: item[key]
          };
          return result;
        }, {});
      });
      setFieldArrays(name, defaultArrayValues, true);
    } else if (immidiate) {
      setFieldArray(name, defaultSchema, true);
    }

    return () => removeFieldArray(name);
  }, [value]);
  const appendEvent = useMemo(() => ({
    count,
    remove: index => removeFieldArray(name, index),
    add: () => setFieldArray(name, defaultSchema, true)
  }), [defaultSchema, count]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, prepend && prepend(appendEvent), states.map((state, index, array) => {
    const lastIndex = array.length - 1;
    const keys = Object.keys(state).filter(key => !!state[key].label);
    const clusters = new Array(Math.ceil(keys.length / column)).fill(0).map((_, index) => keys.slice(index * column, (index + 1) * column));
    const isLastIndex = index === lastIndex;
    const isFirstIndex = index === 0;
    return /*#__PURE__*/React.createElement(Template, _extends({
      key: index
    }, templateProps), tempaltePrepend && tempaltePrepend({ ...state,
      remove: () => {
        removeFieldArray(name, index);
      },
      add: () => {
        setFieldArray(name, defaultSchema, true);
      },
      isLastIndex,
      isFirstIndex
    }), clusters.map((cluster, clusterIndex) => {
      return /*#__PURE__*/React.createElement(Row, {
        key: clusterIndex,
        className: rowClassName
      }, cluster.map((key, keyIndex) => {
        const {
          value,
          showWhen,
          dynamicAttr,
          ...props
        } = schema[key];
        const transformedState = showWhen || dynamicAttr ? transformSchemaToJSON(state) : null;
        return (showWhen ? showWhen(transformedState) : true) ? /*#__PURE__*/React.createElement(Col, {
          key: keyIndex,
          sm: 12 / cluster.length
        }, /*#__PURE__*/React.createElement(InputCore, _extends({
          name: `${name}[${index}].${key}`,
          onChange: formUpdate,
          state: state[key],
          disabled: disabled,
          iconAppend: readonly !== true && showIconAction && clusterIndex === 0 && keyIndex === column - 1 ? /*#__PURE__*/React.createElement("span", {
            title: isLastIndex ? 'add more' : 'remove',
            className: "d-inline-flex align-items-center",
            style: {
              cursor: "pointer"
            },
            onClick: () => {
              if (isLastIndex) {
                setFieldArray(name, defaultSchema, true);
              } else {
                removeFieldArray(name, index);
              }
            }
          }, /*#__PURE__*/React.createElement(Icon, {
            name: isLastIndex ? "plus" : "trash-alt"
          })) : undefined
        }, props, dynamicAttr && dynamicAttr(transformedState)))) : null;
      }));
    }), templateAppend && templateAppend({ ...state,
      remove: () => {
        removeFieldArray(name, index);
      },
      add: () => {
        setFieldArray(name, defaultSchema, true);
      },
      isLastIndex,
      isFirstIndex
    }));
  }), append && append(appendEvent), readonly !== true && (showAction && immidiate && states.length > 1 || !immidiate) && /*#__PURE__*/React.createElement(Button, {
    className: "mb-3",
    block: true,
    disabled: disabled,
    onClick: () => {
      if (states.length > 0) {
        removeFieldArray(name, immidiate ? 0 : undefined, immidiate);
      } else {
        setFieldArray(name, defaultSchema, true);
      }
    }
  }, states.length > 0 ? "REMOVE ALL" : `CREATE ${normalize(name).toLocaleUpperCase()}`));
};

FieldArrayMultiple.defaultProps = {
  immidiate: true,
  showAction: true,
  showIconAction: true,
  column: 2
};
export default FieldArrayMultiple;